import { RecaptchaApiV1Parameter, verify } from "@husky-hrc/Framework/Services/RecaptchaServiceV1";
import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = RecaptchaApiV1Parameter & HasOnSuccess & HasOnError<unknown>;

type Props = {
    apiParameter: RecaptchaApiV1Parameter;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        token: props.parameter.token,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        await verify(props.apiParameter);
    } catch (error) {
        props.error = error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const verifyRecaptcha = createHandlerChainRunner(chain, "VerifyRecaptcha");
export default verifyRecaptcha;
